export default __webpack_public_path__ + "static/media/home-active.b60a074d.svg";